var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('entity-comment-input');
import { breakpoints, theme, TRANSITION } from '@shapeable/theme';
import { MentionsInput, Mention } from 'react-mentions';
import { useQuery, gql } from '@apollo/client';
import { reduce, startsWith, trim } from 'lodash';
// import { ImageElement } from '../elements/image-element';
import { ClipLoader as Spinner } from 'react-spinners';
import { Loader } from '../elements/loader';
import { EntityTypeIcon } from './entity-type-icon';
import { CellLabel } from '../elements/cell-label';
import { useLang } from '../hooks/use-lang';
import { ArrowRightIcon, AtIconGlyph, PaperclipIconGlyph } from '@shapeable/icons';
import { EntityValue } from './entity-value';
import { useWindowWidth } from '@react-hook/window-size';
import { IconButton } from '../elements/icon-button';
import { EntityBubbleImage } from './entity-bubble-image';
import { useEntityTypeDefinitions } from '../context/entity-type-config-context';
import { useAuth } from '../hooks/use-auth';
import { AttachmentPicker } from '../elements/attachment-picker';
import { createUploadEntityEmbedString } from '../utils/create-upload-entity-embed-string';
import { Button } from '../elements/button';
import { ConversationsPreviewAttachments } from '../elements/conversations-preview-attachments';
export var EntityCommentInputDefaultProps = {
  showAvatar: true,
  isReply: false,
  disabled: false,
  variant: 'line',
  initialValue: ''
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    position: relative;\n    align-items: flex-start;\n    overflow: visible;\n    background-color: ", ";\n    border-radius: ", ";\n\n\n    ", "\n\n    ", "\n\n    .entity-comment-input {\n      flex-grow: 1;\n    }\n\n    .entity-comment-input__highlighter {\n       overflow: visible !important;\n       max-height: 150px;\n    }\n\n    .entity-comment-input__input {\n      border: none;\n      font-size: 1em;\n      max-width: 850px;\n      font-family: ", ";\n      color: ", ";\n      \n      ", "\n\n      &::placeholder {\n        color: ", ";\n      }\n\n      &:focus {\n        outline: none;\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    }\n\n    .entity-comment-input__suggestions {\n      overflow-y: auto;\n      max-height: 300px;\n      z-index: 100 !important;\n      min-width: 400px !important;\n      border: 1px solid ", ";\n      border-radius: ", ";\n      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.25);\n    }\n\n    .entity-comment-input__mention {\n      background-color: ", ";\n      margin-left: 1px;\n      margin-top: -1px;\n      border-bottom: 1px solid ", ";\n      border-top: 1px solid ", ";\n      font-weight: 400;\n    }\n\n    entity-comment-input__suggestions__item--focused {\n      color: ", ";\n      background-color: ", ";\n    }\n    \n    .entity-comment-input__suggestions__item {\n      border-bottom: 1px solid ", ";\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    ", "\n  "], ["\n    font-size: ", ";\n    display: flex;\n    position: relative;\n    align-items: flex-start;\n    overflow: visible;\n    background-color: ", ";\n    border-radius: ", ";\n\n\n    ", "\n\n    ", "\n\n    .entity-comment-input {\n      flex-grow: 1;\n    }\n\n    .entity-comment-input__highlighter {\n       overflow: visible !important;\n       max-height: 150px;\n    }\n\n    .entity-comment-input__input {\n      border: none;\n      font-size: 1em;\n      max-width: 850px;\n      font-family: ", ";\n      color: ", ";\n      \n      ", "\n\n      &::placeholder {\n        color: ", ";\n      }\n\n      &:focus {\n        outline: none;\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    }\n\n    .entity-comment-input__suggestions {\n      overflow-y: auto;\n      max-height: 300px;\n      z-index: 100 !important;\n      min-width: 400px !important;\n      border: 1px solid ", ";\n      border-radius: ", ";\n      box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.25);\n    }\n\n    .entity-comment-input__mention {\n      background-color: ", ";\n      margin-left: 1px;\n      margin-top: -1px;\n      border-bottom: 1px solid ", ";\n      border-top: 1px solid ", ";\n      font-weight: 400;\n    }\n\n    entity-comment-input__suggestions__item--focused {\n      color: ", ";\n      background-color: ", ";\n    }\n    \n    .entity-comment-input__suggestions__item {\n      border-bottom: 1px solid ", ";\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    ", "\n  "])), theme.FONT_SIZE(16), theme.COLOR('app-chrome'), theme.UNIT(2), function (props) {
    return (props.isReply || props.isEdit) && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: none;\n      padding-top: ", ";\n    "], ["\n      border: none;\n      padding-top: ", ";\n    "])), theme.UNIT(3));
  }, function (props) {
    return (props.isReply || props.isEdit) && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.20);\n    "], ["\n      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.20);\n    "])));
  }, theme.FONT('sans'), theme.COLOR('text'), function (props) {
    return props.variant === 'box' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        max-width: 100%;\n      "], ["\n        max-width: 100%;\n      "])));
  }, theme.COLOR('text-subtle'), theme.COLOR('text'), theme.COLOR('line-subtle'), theme.UNIT(3), theme.COLOR('primary-very-light'), theme.COLOR('primary-light'), theme.COLOR('primary-very-light'), theme.COLOR('text'), theme.COLOR('subtle'), theme.COLOR('line-subtle'), function (props) {
    return props.disabled && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      .entity-comment-input__input {\n        opacity: 0.2;\n      }\n    "], ["\n      .entity-comment-input__input {\n        opacity: 0.2;\n      }\n    "])));
  }),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(15))
});
var ActiveLineStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 4px;\n    height: 85%;\n    background-color: transparent;\n    border-radius: 0 2px 2px 0;\n    transition: background-color 0.3s ease-in-out;\n\n    ", "\n  "], ["\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 4px;\n    height: 85%;\n    background-color: transparent;\n    border-radius: 0 2px 2px 0;\n    transition: background-color 0.3s ease-in-out;\n\n    ", "\n  "])), function (props) {
    return props.isFocussed && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.COLOR('primary'));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    flex-grow: 1;\n    padding: ", " ", " ", ";\n\n    ", "\n  "], ["\n    flex-grow: 1;\n    padding: ", " ", " ", ";\n\n    ", "\n  "])), theme.UNIT(3), theme.UNIT(3), theme.UNIT(2), function (props) {
    return (props.isReply || props.isEdit) && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding-top: 0;\n    "], ["\n      padding-top: 0;\n    "])));
  })
});
var InputWrapperStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n  "], ["\n  ", "\n  "])), function (props) {
    return props.hasPreviewImages && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    background-color: ", ";\n    border-radius: ", ";\n  "], ["\n    background-color: ", ";\n    border-radius: ", ";\n  "])), theme.COLOR('canvas'), theme.UNIT(2));
  })
});
var InputStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    display: flex;\n    flex-grow: 1;\n    max-height: 150px;\n\n    ", "\n\n    ", "\n  \n    ", "\n\n    ", "\n\n    ", "\n\n   \n  "], ["\n    padding: ", " ", " ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    display: flex;\n    flex-grow: 1;\n    max-height: 150px;\n\n    ", "\n\n    ", "\n  \n    ", "\n\n    ", "\n\n    ", "\n\n   \n  "])), theme.UNIT(3), theme.UNIT(3), theme.UNIT(10), theme.UNIT(2), theme.COLOR('canvas'), function (props) {
    return props.hasPreviewImages && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      height: auto;\n      padding-bottom: ", ";\n    "], ["\n      height: auto;\n      padding-bottom: ", ";\n    "])), theme.UNIT(4));
  }, function (props) {
    return props.variant === 'box' && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      max-width: 100%;\n      box-sizing: border-box;\n      border: 1px solid ", ";\n      background: #FFF;\n    "], ["\n      max-width: 100%;\n      box-sizing: border-box;\n      border: 1px solid ", ";\n      background: #FFF;\n    "])), theme.COLOR('line-subtle'));
  }, function (props) {
    return props.isReply && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      padding-top: ", ";\n      \n    "], ["\n      padding-top: ", ";\n      \n    "])), theme.UNIT(1.5));
  }, function (props) {
    return props.isEdit && css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      padding-top: 0px;\n      \n    "], ["\n      padding-top: 0px;\n      \n    "])));
  }, function (props) {
    return props.isFocussed && css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      border-bottom: none;\n    "], ["\n      border-bottom: none;\n    "])));
  })
});
var SuggestionStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding: ", " ", ";\n\n  "], ["\n    display: flex;\n    align-items: center;\n    padding: ", " ", ";\n\n  "])), theme.UNIT(1.5), theme.UNIT(2))
});
var PhotoStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(2))
});
var SuggestionNameStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: 500;\n    display: flex;\n    flex-direction: column;\n  "], ["\n    font-size: 1em;\n    font-weight: 500;\n    display: flex;\n    flex-direction: column;\n  "])))
});
var ButtonDotDividerStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    font-size: 1.3em;\n     &:before {\n      content: '\u2022';\n      color: ", ";\n    }\n  "], ["\n    font-size: 1.3em;\n     &:before {\n      content: '\u2022';\n      color: ", ";\n    }\n  "])), theme.COLOR('text-subtle')),
  tablet: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    &:before {\n    }\n  "], ["\n    &:before {\n    }\n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    opacity: 0.3;\n    cursor: default;\n    ", "\n  "], ["\n    opacity: 0.3;\n    cursor: default;\n    ", "\n  "])), function (props) {
    return props.hasValue && css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n      opacity: 1;\n      cursor: pointer;\n\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "], ["\n      opacity: 1;\n      cursor: pointer;\n\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "])));
  })
});
var CancelButtonStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    \n    font-size: ", ";\n    margin-left: ", ";\n    padding: ", " ", ";\n\n    font-weight: 500;\n    color: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n\n    &:hover {\n      cursor: pointer;\n      color: ", ";\n      background-color: ", ";\n    }\n  "], ["\n    \n    font-size: ", ";\n    margin-left: ", ";\n    padding: ", " ", ";\n\n    font-weight: 500;\n    color: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n\n    &:hover {\n      cursor: pointer;\n      color: ", ";\n      background-color: ", ";\n    }\n  "])), theme.FONT_SIZE(14), theme.UNIT(1), theme.UNIT(2.1), theme.UNIT(2), theme.COLOR('mid'), theme.COLOR('app-chrome'), theme.UNIT(1), theme.COLOR('mid'), theme.COLOR('just-visible'))
});
var SendIconStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    ", ";\n    padding-left: ", ";\n  "], ["\n    ", ";\n    padding-left: ", ";\n  "])), ButtonStyles, theme.UNIT(2))
});
var CreatorStyles = breakpoints({
  base: css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    margin-right: ", ";\n\n  ", "\n  \n  "], ["\n    margin-right: ", ";\n\n  ", "\n  \n  "])), theme.UNIT(3), function (props) {
    return (props.isEdit || props.isReply) && css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    margin-right: 0;\n    padding-left: ", ";\n  "], ["\n    margin-right: 0;\n    padding-left: ", ";\n  "])), theme.UNIT(3));
  })
});
var SpinnerStyles = breakpoints({
  base: css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    flex-shrink: 0;\n    svg {\n      ", ";\n    }\n  "], ["\n    flex-shrink: 0;\n    svg {\n      ", ";\n    }\n  "])), theme.FILL('primary'))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 0 0 ", " ", ";\n    padding: ", " 0 0;\n    overflow: visible;\n\n    \n    \n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 0 0 ", " ", ";\n    padding: ", " 0 0;\n    overflow: visible;\n\n    \n    \n  "])), theme.UNIT(2), theme.UNIT(2), theme.UNIT(2))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: 1.2em;\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    font-size: ", ";\n    line-height: 1.2em;\n    flex-direction: row;\n    align-items: center;\n  "])), theme.FONT_SIZE(13))
});
var EntityIconStyles = breakpoints({
  base: css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(2))
});
var LabelStyles = breakpoints({
  base: css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    color: ", ";\n    font-size: ", ";\n  "], ["\n    margin-bottom: ", ";\n    color: ", ";\n    font-size: ", ";\n  "])), theme.UNIT(1), theme.COLOR('text-subtle'), theme.FONT_SIZE(12))
});
var TypeLabelStyles = breakpoints({
  base: css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    font-weight: 500;\n    color: ", ";\n  "], ["\n    font-weight: 500;\n    color: ", ";\n  "])), theme.COLOR('primary'))
});
var EntityValueStyles = breakpoints({
  base: css(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    padding: ", ";\n    ", "\n  "], ["\n    padding: ", ";\n    ", "\n  "])), theme.UNIT(3), function (props) {
    return props.focused && css(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), theme.COLOR('primary-very-light'), theme.COLOR('primary-darker'));
  })
});
var AccessPanelControlsStyles = breakpoints({
  base: css(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    position: relative;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    position: relative;\n  "])))
});
var InputControlsStyles = breakpoints({
  base: css(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    display: flex;\n    gap: ", ";\n    flex-direction: row;\n    align-items: center;\n  "])), theme.UNIT(2))
});
var PreviewAttachmentsStyles = breakpoints({
  base: css(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AccessPanelControlButtonStyles = breakpoints({
  base: css(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n    transition: background-color 0.3s;\n    border-radius: 50%;\n\n    &:hover {\n      background-color: ", ";\n    }\n  "], ["\n    transition: background-color 0.3s;\n    border-radius: 50%;\n\n    &:hover {\n      background-color: ", ";\n    }\n  "])), theme.COLOR('just-visible'))
});
var ModalOpenButtonStyles = breakpoints({
  base: css(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ButtonDotDividerStyles)
});
var ModalCloseButtonStyles = breakpoints({
  base: css(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ButtonDotDividerStyles)
});
var UploadAttachmentPickerModalStyles = breakpoints({
  base: css(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n    position: absolute;\n    top: -100px;\n    left: 40px;\n    z-index: 100;\n    margin-bottom: ", ";\n\n    @keyframes slideUp {\n      from {\n        opacity: 0;\n        transform: translateY(20px);\n      }\n      to {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    animation: slideUp 0.3s ease-out forwards;\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    position: absolute;\n    top: -100px;\n    left: 40px;\n    z-index: 100;\n    margin-bottom: ", ";\n\n    @keyframes slideUp {\n      from {\n        opacity: 0;\n        transform: translateY(20px);\n      }\n      to {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n\n    animation: slideUp 0.3s ease-out forwards;\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme.UNIT(2), theme.COLOR('primary'))
});
var AtMentionButtonStyles = breakpoints({
  base: css(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n    margin-left: -", ";\n    overflow: visible;\n  "], ["\n    margin-left: -", ";\n    overflow: visible;\n  "])), theme.UNIT(1.5))
});
var SendButtonStyles = breakpoints({
  base: css(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n    border-radius: ", ";\n    border: none;\n    padding: ", " ", ";\n\n    &:hover {\n      filter: brightness(1.1);\n      ", ";\n    } \n\n    ", "\n  "], ["\n    border-radius: ", ";\n    border: none;\n    padding: ", " ", ";\n\n    &:hover {\n      filter: brightness(1.1);\n      ", ";\n    } \n\n    ", "\n  "])), theme.UNIT(1), theme.UNIT(2), theme.UNIT(2), TRANSITION('filter'), function (_a) {
    var hasValue = _a.hasValue;
    return !hasValue && css(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n      &:hover {\n        filter: none;\n      }\n    "], ["\n      &:hover {\n        filter: none;\n      }\n    "])));
  })
});
var ModalStyles = breakpoints({
  base: css(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n    position: absolute,\n    top: 35,\n    left: 60,\n    z-index: 100,\n    marginBottom: 8,\n  "], ["\n    position: absolute,\n    top: 35,\n    left: 60,\n    z-index: 100,\n    marginBottom: 8,\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ActiveLine: styled.div(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), ActiveLineStyles),
  Avatar: styled(EntityBubbleImage)(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), CreatorStyles),
  Body: styled.div(templateObject_52 || (templateObject_52 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  InputWrapper: styled.div(templateObject_53 || (templateObject_53 = __makeTemplateObject(["", ""], ["", ""])), InputWrapperStyles),
  Input: styled.div.attrs(cls.attr('input'))(templateObject_54 || (templateObject_54 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Suggestion: styled.div(templateObject_55 || (templateObject_55 = __makeTemplateObject(["", ""], ["", ""])), SuggestionStyles),
  Label: styled(CellLabel)(templateObject_56 || (templateObject_56 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  TypeLabel: styled(CellLabel)(templateObject_57 || (templateObject_57 = __makeTemplateObject(["", ""], ["", ""])), TypeLabelStyles),
  SuggestionName: styled.span(templateObject_58 || (templateObject_58 = __makeTemplateObject(["", ""], ["", ""])), SuggestionNameStyles),
  Photo: styled(EntityBubbleImage)(templateObject_59 || (templateObject_59 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  // Image: styled(ImageElement)`${ImageStyles}`,
  PreviewAttachments: styled(ConversationsPreviewAttachments)(templateObject_60 || (templateObject_60 = __makeTemplateObject(["", ""], ["", ""])), PreviewAttachmentsStyles),
  Spinner: styled(Spinner)(templateObject_61 || (templateObject_61 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles),
  Loader: styled(Loader)(templateObject_62 || (templateObject_62 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  EntityTypeIcon: styled(EntityTypeIcon)(templateObject_63 || (templateObject_63 = __makeTemplateObject(["", ""], ["", ""])), EntityIconStyles),
  EntityValue: styled(EntityValue)(templateObject_64 || (templateObject_64 = __makeTemplateObject(["", ""], ["", ""])), EntityValueStyles),
  Controls: styled.div(templateObject_65 || (templateObject_65 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  InputControls: styled.div(templateObject_66 || (templateObject_66 = __makeTemplateObject(["", ""], ["", ""])), InputControlsStyles),
  CancelButton: styled(IconButton)(templateObject_67 || (templateObject_67 = __makeTemplateObject(["", ""], ["", ""])), CancelButtonStyles),
  SaveButton: styled(IconButton)(templateObject_68 || (templateObject_68 = __makeTemplateObject(["", ""], ["", ""])), CancelButtonStyles),
  SendIcon: styled(IconButton)(templateObject_69 || (templateObject_69 = __makeTemplateObject(["", ""], ["", ""])), SendIconStyles),
  AtMentionButton: styled(IconButton)(templateObject_70 || (templateObject_70 = __makeTemplateObject(["", ""], ["", ""])), AtMentionButtonStyles),
  SendButton: styled(Button)(templateObject_71 || (templateObject_71 = __makeTemplateObject(["", ""], ["", ""])), SendButtonStyles),
  AccessPanelControls: styled.div(templateObject_72 || (templateObject_72 = __makeTemplateObject(["", ""], ["", ""])), AccessPanelControlsStyles),
  ModalOpenButton: styled(IconButton)(templateObject_73 || (templateObject_73 = __makeTemplateObject(["", ""], ["", ""])), ModalOpenButtonStyles),
  ModalCloseButton: styled(IconButton)(templateObject_74 || (templateObject_74 = __makeTemplateObject(["", ""], ["", ""])), ModalCloseButtonStyles),
  Modal: styled.div(templateObject_75 || (templateObject_75 = __makeTemplateObject(["", ""], ["", ""])), ModalStyles),
  UploadAttachmentPickerModal: styled(AttachmentPicker)(templateObject_76 || (templateObject_76 = __makeTemplateObject(["", ""], ["", ""])), UploadAttachmentPickerModalStyles)
};
// NEW helper: extracts id from embed string
var extractEmbedId = function (embed) {
  var match = embed.match(/id="([^"]+)"/);
  return match ? match[1] : null;
};
export var EntityCommentInput = function (props) {
  var t = useLang();
  var activePerson = useAuth();
  var entities = useEntityTypeDefinitions();
  var windowWidth = useWindowWidth();
  var _a = __read(useState(false), 2),
    focussed = _a[0],
    setFocussed = _a[1];
  var buttonRef = useRef(null);
  var inputRef = useRef(null);
  var ref = useRef();
  var className = props.className,
    showAvatar = props.showAvatar,
    isReply = props.isReply,
    onSubmit = props.onSubmit,
    isEdit = props.isEdit,
    isSubmitting = props.isSubmitting,
    initialValue = props.initialValue,
    disabled = props.disabled,
    autoFocus = props.autoFocus,
    onCancel = props.onCancel,
    variant = props.variant,
    isMainInput = props.isMainInput;
  var placeholder = t(props.placeholder || (isReply ? windowWidth < 600 ? 'Write a reply - type @ to mention, paste links to embed them' : 'Reply, @mention, paste links' : windowWidth < 600 ? 'Comment, @mention, paste links' : 'Write a comment - type @ to mention, paste links to embed them'));
  var mentioneableEntities = ['Person', 'Team', 'Organisation', 'FeedEntry', 'Video'];
  var MENTIONS_QUERY = useMemo(function () {
    var inner = reduce(mentioneableEntities, function (acc, entityTypeName) {
      var defn = entities[entityTypeName];
      if (true) {
        return "\n          ".concat(acc, "\n\n          list").concat(defn.pluralLabel).concat(entityTypeName === 'Person' ? "(filter: { hasAccount: { is: true } })" : '', " {\n            results {\n              id\n              name\n              slug\n              openGraph { id image { id url } }\n            }\n          }\n        ");
      }
      return acc;
    }, '');
    return gql(templateObject_77 || (templateObject_77 = __makeTemplateObject(["\n      query MentionsQuery {\n        ", "\n      }\n    "], ["\n      query MentionsQuery {\n        ", "\n      }\n    "])), inner);
  }, [activePerson]);
  var _b = useQuery(MENTIONS_QUERY),
    _c = _b.data,
    data = _c === void 0 ? {} : _c,
    loading = _b.loading;
  var allEntities = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(data.listPeople && data.listPeople.results || []), false), __read(data.listTeams && data.listTeams.results || []), false), __read(data.listOrganisations && data.listOrganisations.results || []), false), __read(data.listFeedEntries && data.listFeedEntries.results || []), false), __read(data.listVideos && data.listVideos.results || []), false);
  var postLabel = t('Send');
  var cancelLabel = t('Cancel');
  var saveLabel = t('Save');
  var replyLabel = t('Reply');
  // const { person } = personResult;
  // const creator = props.creator || person;
  var creator = props.creator;
  useEffect(function () {
    // Moving cursor to the end
    if (autoFocus && inputRef && inputRef.current) {
      inputRef.current.selectionStart = inputRef.current.value.length;
      inputRef.current.selectionEnd = inputRef.current.value.length;
    }
  }, []);
  var _d = __read(React.useState(initialValue), 2),
    value = _d[0],
    setValue = _d[1];
  // NEW: State to hold attachments separately so embed strings aren't shown in the input.
  var _e = __read(useState([]), 2),
    embedAttachments = _e[0],
    setEmbedAttachments = _e[1];
  var _f = __read(useState([]), 2),
    createdEntities = _f[0],
    setCreatedEntities = _f[1];
  var _g = __read(useState(false), 2),
    isVisible = _g[0],
    setIsVisible = _g[1];
  var closeDialogModal = function () {
    setIsVisible(false);
  };
  var toggleVisibility = function () {
    return setIsVisible(!isVisible);
  };
  var handleClickOutside = function (event) {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      closeDialogModal();
    }
  };
  useEffect(function () {
    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);
  var hasPreviewImages = !!createdEntities.length;
  var onChange = function (event, newValue, newPlainTextValue, options) {
    setValue(newValue);
  };
  // END TODO
  // If the input is in edit mode and has an initial value, extract any attachmnts from the inital value to not show the embed string
  // then re-add the attachments to the input value when submitting or cancelling the form. 
  useEffect(function () {
    if (isEdit && initialValue) {
      // Combined regex to match both ImageAsset and FileAsset embed strings
      var embedRegex = /<(ImageAsset|FileAsset)[^>]+\/>/g;
      var embeds = initialValue.match(embedRegex) || [];
      if (embeds.length) {
        var parsed = embeds.map(function (embedStr) {
          var id = extractEmbedId(embedStr);
          return {
            embed: embedStr,
            id: id
          };
        });
        setEmbedAttachments(parsed);
        setValue(initialValue.replace(embedRegex, '').trim());
      }
    }
  }, [isEdit, initialValue]);
  var handleAtInput = function () {
    setValue(function (prev) {
      return prev ? prev + '@' : '@';
    });
    inputRef.current.focus();
  };
  var handleSubmit = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var commentText;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            commentText = value + (embedAttachments.length ? "\n" + embedAttachments.map(function (a) {
              return a.embed;
            }).join(" ") : "");
            if (!onSubmit) return [3 /*break*/, 2];
            return [4 /*yield*/, onSubmit({
              value: commentText
            })];
          case 1:
            _a.sent();
            setCreatedEntities([]);
            setEmbedAttachments([]);
            setValue('');
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };
  var handleKeyDown = function (event) {
    if (event.keyCode === 13 && !event.shiftKey) {
      handleSubmit();
    } else if (event.keyCode === 27) {
      handleCancel();
    }
  };
  var handleCancel = function () {
    setValue('');
    if (onCancel) {
      onCancel();
    }
  };
  var renderSuggestion = function (entry, search, highlightedDisplay, index, focused) {
    var defn = entities[entry.__typename];
    var label = defn && defn.label;
    return React.createElement(My.EntityValue, {
      variant: 'small',
      highlight: search,
      focused: focused,
      entity: entry
    });
  };
  // const mentionEntity: (search: string, callback: (data: EntitySuggestion[]) => void) => void = 
  //   async (search, callback) => {
  //   if (search) {
  //     if (allEntities.length) {
  //       const filteredResults = filter(allEntities, result => (!creator || (result.id !== creator.id)) && (search ?  startsWith(result.name.toUpperCase(), search.toUpperCase()) : true));
  //       const mappedResults = filteredResults.map((entity: Entity) => ({ ...entity, id: `${(entities[entity.__typename] && `${entities[entity.__typename].pluralLabel.toLocaleLowerCase()}/`)}${entity.slug}`, display: entity.name }));
  //       callback(mappedResults);
  //     }
  //   }
  //   return [];
  // };
  var mentionEntity = function (search, callback) {
    return __awaiter(void 0, void 0, void 0, function () {
      var filteredResults, mappedResults;
      return __generator(this, function (_a) {
        filteredResults = allEntities.filter(function (result) {
          return (!creator || result.id !== creator.id) && (search ? startsWith(result.name.toUpperCase(), search.toUpperCase()) : true);
        });
        mappedResults = filteredResults.map(function (entity) {
          return __assign(__assign({}, entity), {
            id: "".concat(entities[entity.__typename] ? "".concat(entities[entity.__typename].pluralLabel.toLowerCase(), "/") : '').concat(entity.slug),
            display: entity.name
          });
        });
        callback(mappedResults);
        return [2 /*return*/];
      });
    });
  };
  var avatarSize = isReply ? 32 : 40;
  var hasValue = !!trim(value) || !!embedAttachments.length;
  var showControls = hasValue || isEdit;
  // const modal = useModal();
  var onFocus = function () {
    return setFocussed(true);
  };
  var onBlur = function () {
    return setFocussed(false);
  };
  return React.createElement(My.Container, {
    ref: ref,
    variant: variant,
    disabled: disabled || isSubmitting,
    className: className,
    isFocussed: focussed,
    isEdit: isEdit,
    isReply: isReply
  }, (isReply || isEdit) && React.createElement(My.ActiveLine, {
    isFocussed: focussed
  }), creator && showAvatar && React.createElement(My.Avatar, {
    size: avatarSize,
    entity: creator,
    isEdit: isEdit,
    isReply: isReply
  }), React.createElement(My.Body, {
    isEdit: isEdit,
    isReply: isReply,
    isFocussed: focussed
  }, React.createElement(My.InputWrapper, {
    isEdit: isEdit,
    isReply: isReply,
    isFocussed: focussed,
    hasPreviewImages: hasPreviewImages
  }, React.createElement(My.Input, {
    title: t('Use the Return key to submit. To force a line-break, use Shift-Return.'),
    isFocussed: focussed,
    disabled: disabled,
    variant: variant,
    isEdit: isEdit,
    isReply: isReply,
    hasPreviewImages: hasPreviewImages
  }, React.createElement(MentionsInput, {
    allowSuggestionsAboveCursor: true,
    forceSuggestionsAboveCursor: true,
    inputRef: inputRef,
    onKeyDown: handleKeyDown,
    autoFocus: autoFocus,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled || isSubmitting,
    placeholder: placeholder,
    className: "entity-comment-input",
    value: value,
    suggestionsPortalHost: ref && ref.current,
    onChange: onChange
  }, React.createElement(Mention, {
    trigger: "@",
    markup: "@[__display__](/__id__)",
    data: mentionEntity,
    className: "entity-comment-input__mention",
    renderSuggestion: renderSuggestion,
    appendSpaceOnAdd: true
  }))), !!createdEntities.length && createdEntities.map(function (attachment, index) {
    return React.createElement(My.PreviewAttachments, {
      key: index,
      entity: attachment,
      onDeleted: function () {
        setCreatedEntities(function (prev) {
          return prev.filter(function (e) {
            return e.id !== attachment.id;
          });
        });
      }
    });
  })),
  // showControls &&
  React.createElement(My.Controls, {
    isEdit: isEdit,
    isReply: isReply,
    hasValue: hasValue,
    isFocussed: focussed,
    isLoading: isSubmitting
  }, React.createElement(React.Fragment, null, React.createElement(My.AccessPanelControls, {
    ref: buttonRef
  }, React.createElement(My.AtMentionButton, {
    hoverState: 'halo',
    iconColor: 'mid',
    iconSize: 18,
    icon: React.createElement(AtIconGlyph, null),
    onClick: handleAtInput
  }), isVisible ? React.createElement(My.ModalCloseButton, {
    hoverState: 'halo',
    iconColor: 'primary',
    iconSize: 20,
    icon: React.createElement(PaperclipIconGlyph, null),
    onClick: toggleVisibility
  }) : React.createElement(My.ModalOpenButton, {
    disabled: hasPreviewImages,
    hoverState: 'halo',
    iconColor: 'mid',
    iconSize: 20,
    icon: React.createElement(PaperclipIconGlyph, null),
    onClick: toggleVisibility
  }), isVisible && React.createElement(My.UploadAttachmentPickerModal, {
    onEntityCreated: function (createdEntity) {
      var createImageAsset = createdEntity.createImageAsset,
        createFileAsset = createdEntity.createFileAsset;
      var embedString = createUploadEntityEmbedString(createdEntity);
      var embedId = extractEmbedId(embedString);
      setEmbedAttachments(function (prev) {
        return __spreadArray(__spreadArray([], __read(prev), false), [{
          embed: embedString,
          id: embedId
        }], false);
      });
      setCreatedEntities(function (prev) {
        return __spreadArray(__spreadArray([], __read(prev), false), [createImageAsset || createFileAsset], false);
      });
      closeDialogModal();
    }
  })), React.createElement(My.InputControls, null, (isEdit || isReply) && React.createElement(My.CancelButton, {
    showChildren: true,
    hasValue: hasValue,
    onClick: handleCancel
  }, cancelLabel), isSubmitting ? React.createElement(My.Loader, {
    spaceUnits: 2,
    spinnerSize: 16
  }, isEdit ? t('Updating...') : t('Sending...')) : React.createElement(My.SendButton, {
    borderStyle: 'solid',
    variant: 'slim',
    hasValue: hasValue,
    disabled: !hasValue,
    icon: ArrowRightIcon,
    colors: {
      text: 'canvas',
      fill: 'canvas',
      background: 'primary'
    },
    onClick: function () {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, handleSubmit()];
            case 1:
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    }
  }, isEdit ? saveLabel : isReply ? replyLabel : postLabel))))));
};
EntityCommentInput.defaultProps = EntityCommentInputDefaultProps;
EntityCommentInput.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77;